import React, { useState, useEffect, useCallback } from 'react';
import {
  CardBody,
  Row,
  Col,
  Card,
  Container,
  CardHeader,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Label,
  Input,
  Button,
} from 'reactstrap';
import DataTable from 'react-data-table-component';
import Select from 'react-select';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import DeleteModal from '../../Components/Common/DeleteModal';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { api } from '../../config';
import { getAuthToken } from '../../auth/tokenvalidation';
import { UoMType, PricingUnitType } from '../../constants/masterData';

const ProductTypeList = () => {
  const token = getAuthToken();

  const [data, setData] = useState({ items: [] });
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [invoice, setInvoice] = useState(null);
  const [errors, setErrors] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [modalProductType, setModalProductType] = useState(false);
  const [productTypeFormData, setProductTypeFormData] = useState({
    productId: '',
    name: '',
    description: '',
    id: null,
  });

  const [filterText, setFilterText] = useState('');
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState('');

  const handleDeleteModal = id => {
    const selectedRow = data.items.find(item => item.id === id);
    setInvoice(selectedRow);
    setDeleteModal(true);
  };

  const handleDeleteInvoice = async () => {
    if (invoice) {
      try {
        const response = await fetch(
          `${api.API_URL}/product-type/${invoice.id}`,
          {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(
            errorData.message || `HTTP error! status: ${response.status}`
          );
        }

        toast.success('Product Type berhasil dihapus!', {
          autoClose: 3000,
        });
        setDeleteModal(false);
        setInvoice(null);
        const filters = {
          productId: selectedProduct,
          searchText: filterText,
        };
        fetchData(currentPage, rowsPerPage, token, filters);
      } catch (err) {
        toast.error(`Gagal menghapus product type: ${err.message}`, {
          autoClose: 3000,
        });
      }
    }
  };

  const deleteMultiple = () => {
    // Implement multiple delete functionality
    // This would typically involve deleting selected items
    // For now, just close the modal
    setDeleteModalMulti(false);
  };

  const columns = [
    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          Product Type Name
        </span>
      ),
      selector: row => row.name,
      sortable: true,
      width: '20%',
      wrap: true,
      cell: row => {
        return (
          <>
            <h6 className={'mb-0'}>{row.name}</h6>
          </>
        );
      },
    },

    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          Product
        </span>
      ),
      selector: row => row.product?.name,
      sortable: true,
      width: '20%',
      wrap: true,
      cell: row => {
        return (
          <>
            <h6 className={'mb-0'}>{row.product?.name || '-'}</h6>
          </>
        );
      },
    },

    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          UoM
        </span>
      ),
      selector: row => row.uoM,
      sortable: true,
      width: '10%',
      wrap: true,
      cell: row => {
        return (
          <>
            <h6 className={'mb-0'}>{row.uoM || '-'}</h6>
          </>
        );
      },
    },

    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          Pricing Unit
        </span>
      ),
      selector: row => row.pricingUnit,
      sortable: true,
      width: '10%',
      wrap: true,
      cell: row => {
        return (
          <>
            <h6 className={'mb-0'}>{row.pricingUnit || '-'}</h6>
          </>
        );
      },
    },

    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          Description
        </span>
      ),
      selector: row => row.description,
      sortable: true,
      width: '30%',
      wrap: true,
      cell: row => {
        return (
          <>
            <h6 className={'mb-0'}>{row.description || '-'}</h6>
          </>
        );
      },
    },

    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          Action
        </span>
      ),
      width: '10%',
      sortable: false,
      className: 'text-end',
      center: true,
      cell: row => (
        <div className='d-flex gap-1 justify-content-end'>
          <button
            className='btn btn-soft-info btn-sm btn-icon'
            onClick={() => handleUpdateModal(row.id)}
          >
            <i className='ri-pencil-fill align-bottom'></i>
          </button>
          <button
            className='btn btn-soft-danger btn-sm btn-icon'
            onClick={() => handleDeleteModal(row.id)}
          >
            <i className='ri-delete-bin-6-line align-bottom'></i>
          </button>
        </div>
      ),
    },
  ];

  document.title = 'Data Product Type';

  const handleChange = e => {
    const { name, value } = e.target;
    setProductTypeFormData({ ...productTypeFormData, [name]: value });
  };

  useEffect(() => {
    const filters = {
      productId: selectedProduct,
      searchText: filterText,
    };
    fetchData(currentPage, rowsPerPage, token, filters);
    fetchProducts(token);
  }, [currentPage, rowsPerPage, token, selectedProduct, filterText]);

  const handleFilterChange = e => {
    setFilterText(e.target.value);
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handleProductFilterChange = e => {
    setSelectedProduct(e.target.value);
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const clearAllFilters = () => {
    setFilterText('');
    setSelectedProduct('');
    setCurrentPage(1); // Reset to first page when clearing filters
  };

  const fetchData = async (currentPage, rowsPerPage, token, filters = {}) => {
    setLoading(true);
    try {
      // Build query parameters
      const queryParams = new URLSearchParams({
        PageNumber: currentPage.toString(),
        PageSize: rowsPerPage.toString(),
      });

      // Add filter parameters if they exist
      if (filters.productId) {
        queryParams.append('ProductId', filters.productId);
      }
      if (filters.searchText) {
        queryParams.append('Name', filters.searchText);
      }

      const url = `${api.API_URL}/product-type?${queryParams.toString()}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      // Handle different possible response structures
      const items =
        result?.data?.items || result?.items || result?.data || result || [];
      const totalItems =
        result?.data?.totalItems || result?.totalItems || items.length;

      setData({
        items: Array.isArray(items) ? items : [],
      });
      setTotalRows(totalItems);
    } catch (error) {
      toast.error(`Failed to load data: ${error.message}`);
      setData({ items: [] });
      setTotalRows(0);
    } finally {
      setLoading(false);
    }
  };

  const fetchProducts = async token => {
    try {
      const response = await fetch(`${api.API_URL}/product`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      const items =
        result?.data?.items || result?.items || result?.data || result || [];
      setProducts(Array.isArray(items) ? items : []);
    } catch (error) {
      toast.error(`Failed to load products: ${error.message}`);
      setProducts([]);
    }
  };

  const handlePageChange = useCallback(page => {
    setCurrentPage(page);
  }, []);

  const handlePerRowsChange = useCallback(newPerPage => {
    setRowsPerPage(newPerPage);
    setCurrentPage(1);
  }, []);

  const handleNewModal = () => {
    setProductTypeFormData({
      productId: '',
      name: '',
      description: '',
      id: null,
    });
    productTypeModal();
  };

  const handleUpdateModal = (mid = null) => {
    fetchProductTypeDetail(mid);
    productTypeModal();
  };

  const productTypeModal = () => {
    setModalProductType(!modalProductType);
  };

  const selectedFieldsProductType = {
    productId: productTypeFormData.productId,
    name: productTypeFormData.name,
    description: productTypeFormData.description,
    uoM: productTypeFormData.uoM,
    pricingUnit: productTypeFormData.pricingUnit,
  };

  const handleAddDataProductType = async () => {
    try {
      await axios.post(
        `${api.API_URL}/product-type`,
        selectedFieldsProductType,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(`Product Type Has been Added`);
    } catch (error) {
      toast.error(`Failed to save data: ${error.message}`);
    } finally {
      const filters = {
        productId: selectedProduct,
        searchText: filterText,
      };
      fetchData(currentPage, rowsPerPage, token, filters);
    }
  };

  const fetchProductTypeDetail = async mid => {
    try {
      const response = await axios.get(`${api.API_URL}/product-type/${mid}`, {
        withXSRFToken: true,
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: `application/json`,
        },
      });
      const data = response;
      setProductTypeFormData({
        productId: data.productId || '',
        name: data.name || '',
        description: data.description || '',
        uoM: data.uoM || '',
        pricingUnit: data.pricingUnit || '',
        id: data.id || null,
      });
    } catch (error) {
      toast.error(`Failed to fetch product type details: ${error.message}`);
    }
  };

  const handleUpdDataProductType = async mid => {
    try {
      await axios.put(
        `${api.API_URL}/product-type/${mid}`,
        selectedFieldsProductType,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(`Data Has been Updated`);
    } catch (error) {
      toast.error(`Failed to save data: ${error.message}`);
    } finally {
      const filters = {
        productId: selectedProduct,
        searchText: filterText,
      };
      fetchData(currentPage, rowsPerPage, token, filters);
    }
  };

  const handleSelectChange = (e, field) => {
    const value = e ? e.value : '';
    setProductTypeFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <React.Fragment>
      <div className='page-content'>
        <DeleteModal
          show={deleteModal}
          onDeleteClick={() => handleDeleteInvoice()}
          onCloseClick={() => setDeleteModal(false)}
        />
        <DeleteModal
          show={deleteModalMulti}
          onDeleteClick={() => {
            deleteMultiple();
            setDeleteModalMulti(false);
          }}
          onCloseClick={() => setDeleteModalMulti(false)}
        />
        <Container fluid>
          <BreadCrumb title='View Data' pageTitle='Product Type' />

          <Row>
            <Col lg={12}>
              <Card id='ProductTypeList'>
                <CardHeader className='border-0'>
                  <div className='d-flex align-items-center'>
                    <h5 className='card-title mb-0 flex-grow-1'>
                      Data Product Type
                    </h5>
                    <div className='flex-shrink-0'>
                      <div className='d-flex gap-2 flex-wrap'>
                        <button
                          type='button'
                          className='btn btn-primary btn-label right ms-auto nexttab btn-sm'
                          onClick={() => handleNewModal()}
                        >
                          <i className='ri-play-list-add-line label-icon align-middle fs-16 ms-2'></i>{' '}
                          <span className='d-none d-sm-inline'>
                            Create New Product Type
                          </span>
                          <span className='d-sm-none'>New</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Filter Section */}
                  <div className='mt-3'>
                    <Row>
                      <Col md={4}>
                        <div className='d-flex align-items-center gap-2'>
                          <Input
                            type='text'
                            placeholder='Search product types...'
                            value={filterText}
                            onChange={handleFilterChange}
                            className='form-control-sm'
                          />
                        </div>
                      </Col>
                      <Col md={4}>
                        <Input
                          type='select'
                          value={selectedProduct}
                          onChange={handleProductFilterChange}
                          className='form-control-sm'
                        >
                          <option value=''>All Products</option>
                          {products.map(product => (
                            <option key={product.id} value={product.id}>
                              {product.name}
                            </option>
                          ))}
                        </Input>
                      </Col>
                      <Col md={4}>
                        {(filterText || selectedProduct) && (
                          <Button
                            color='secondary'
                            size='sm'
                            onClick={clearAllFilters}
                            outline
                          >
                            <i className='ri-close-line'></i> Clear All
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </div>
                </CardHeader>

                <CardBody className='pt-0'>
                  <div
                    className='table-responsive'
                    style={{
                      minHeight: 'auto',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <DataTable
                      columns={columns}
                      highlightOnHover
                      data={data.items}
                      pagination
                      paginationServer={true}
                      paginationTotalRows={totalRows}
                      onChangePage={handlePageChange}
                      onChangeRowsPerPage={handlePerRowsChange}
                      showPaginationBottom={true}
                      wrap
                      dense
                      striped
                      progressPending={loading}
                      fixedHeader={false}
                      fixedHeaderScrollHeight={undefined}
                      noDataComponent={
                        <div
                          style={{
                            padding: '20px',
                            textAlign: 'center',
                            color: '#6c757d',
                          }}
                        >
                          <i
                            className='ri-database-2-line'
                            style={{
                              fontSize: '32px',
                              marginBottom: '8px',
                              display: 'block',
                            }}
                          ></i>
                          {filterText || selectedProduct
                            ? 'No product types match the current filters'
                            : 'No product types found'}
                        </div>
                      }
                      defaultSortFieldId={1}
                      defaultSortAsc={true}
                      customStyles={{
                        header: {
                          style: {
                            backgroundColor: '#f0f0f0',
                            color: '#333',
                            fontWeight: 'bold',
                          },
                        },
                        headCells: {
                          style: {
                            backgroundColor: '#f0f0f0',
                            fontWeight: 'bold',
                            fontSize: '14px',
                            paddingLeft: '12px',
                            paddingRight: '12px',
                            borderRight: '1px solid #dee2e6',
                          },
                        },
                        cells: {
                          style: {
                            paddingLeft: '12px',
                            paddingRight: '12px',
                            wordBreak: 'break-word',
                            borderRight: '1px solid #dee2e6',
                          },
                        },
                        rows: {
                          style: {
                            minHeight: '50px',
                            '&:hover': {
                              backgroundColor: '#f8f9fa',
                            },
                          },
                        },
                        table: {
                          style: {
                            width: '100%',
                            minWidth: '100%',
                            tableLayout: 'fixed',
                          },
                        },
                        responsiveWrapper: {
                          style: {
                            overflowX: 'hidden',
                            display: 'flex',
                            flexDirection: 'column',
                          },
                        },
                        pagination: {
                          style: {
                            borderTop: '1px solid #dee2e6',
                            backgroundColor: '#f8f9fa',
                            margin: 0,
                            padding: '8px 0',
                          },
                        },
                      }}
                    />

                    <ToastContainer closeButton={false} limit={1} />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal
            isOpen={modalProductType}
            role='dialog'
            autoFocus={true}
            centered
            id='addProductTypeModal'
            toggle={productTypeModal}
            data-bs-backdrop='static'
            size='md'
          >
            <ModalHeader
              className='bg-soft-info'
              toggle={() => {
                setModalProductType(!modalProductType);
              }}
            >
              <span className='modal-title text-info fw-bold'>
                {productTypeFormData.id !== null
                  ? 'Edit Product Type'
                  : 'Add Product Type'}
              </span>
            </ModalHeader>

            <ModalBody>
              <div className='d-flex mt-2'>
                <Col sm={12}>
                  <Row>
                    <Col sm={12}>
                      <div className='mb-3'>
                        <Label for='product' className='form-label '>
                          Product :
                        </Label>
                        <div className='input-group'>
                          <Input
                            type='select'
                            id='productId'
                            name='productId'
                            className='form-control'
                            value={productTypeFormData.productId || ''}
                            onChange={e => {
                              handleChange(e);
                              setErrors({
                                ...errors,
                                productId: '',
                              });
                            }}
                          >
                            <option value=''>Select Product</option>
                            {products.map(product => (
                              <option key={product.id} value={product.id}>
                                {product.name}
                              </option>
                            ))}
                          </Input>
                        </div>
                      </div>
                    </Col>
                    <Col sm={12}>
                      <div className='mb-3'>
                        <Label for='product-type-name' className='form-label '>
                          Product Type Name :
                        </Label>
                        <div className='input-group'>
                          <Input
                            type='text'
                            id='name'
                            name='name'
                            className='form-control'
                            value={productTypeFormData.name || ''}
                            onChange={e => {
                              handleChange(e);
                              setErrors({
                                ...errors,
                                name: '',
                              });
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col sm={12}>
                      <div className='mb-2'>
                        <p className='form-label '>UoM </p>
                        <Select
                          id='uoM'
                          name='uoM'
                          options={UoMType}
                          placeholder='Please Select'
                          isClearable
                          value={
                            UoMType[0].options.find(
                              option => option.value === productTypeFormData.uoM
                            ) || null
                          }
                          onChange={e => {
                            handleSelectChange(e, 'uoM');
                          }}
                        />
                      </div>
                    </Col>

                    <Col sm={12}>
                      <div className='mb-2'>
                        <p className='form-label '>Pricing Unit</p>
                        <Select
                          id='pricingUnit'
                          name='pricingUnit'
                          options={PricingUnitType}
                          placeholder='Please Select'
                          isClearable
                          value={
                            PricingUnitType[0].options.find(
                              option =>
                                option.value === productTypeFormData.pricingUnit
                            ) || null
                          }
                          onChange={e => {
                            handleSelectChange(e, 'pricingUnit');
                          }}
                        />
                      </div>
                    </Col>

                    <Col sm={12}>
                      <div className='mb-3'>
                        <Label htmlFor='description' className='form-label'>
                          Description{' '}
                        </Label>
                        <textarea
                          className='form-control'
                          id='description'
                          name='description'
                          rows='3'
                          value={productTypeFormData.description || ''}
                          onChange={e => {
                            handleChange(e);
                            setErrors({
                              ...errors,
                              description: '',
                            });
                          }}
                        ></textarea>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </div>
            </ModalBody>

            <ModalFooter>
              <Button
                color='danger'
                className='btn-label btn-sm right'
                onClick={() => {
                  setModalProductType(!modalProductType);
                }}
              >
                {' '}
                <i className=' ri-close-circle-line label-icon align-middle fs-16 ms-2'></i>{' '}
                Close
              </Button>
              <Button
                color='primary'
                className='btn-label btn-sm right'
                onClick={() => {
                  setModalProductType(!modalProductType);
                  productTypeFormData.id !== null
                    ? handleUpdDataProductType(productTypeFormData.id)
                    : handleAddDataProductType();
                }}
              >
                {' '}
                <i className='ri-database-2-line label-icon align-middle fs-16 ms-2'></i>{' '}
                {productTypeFormData.id !== null ? 'Update' : 'Save'}
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ProductTypeList;
